import React from 'react';

function SplashScreen({ isVisible }) {
  return (
    <div className={`splash-screen ${!isVisible ? 'fade-out' : ''}`}>
      <div className="splash-content">
        <img 
          src="/images/logo/logotransparente.png" 
          alt="Logo" 
          className="splash-logo"
        />
      </div>
    </div>
  );
}

export default SplashScreen;
